import gql from "graphql-tag";

export const UPDATE_WEPA_DIRECTOR_DETAILS = gql`
  mutation UpdateWepaDirectorDetails($id: ID!, $director: ShareholderPerson!) {
    updateDirectorDetails(wepaServiceId: $id, director: $director) {
      feedback
    }
  }
`;
